// Module
var code = "<?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=\"80px\" height=\"74px\" viewBox=\"0 0 80 74\"> <path d=\"M37,34 L37,25 L43,25 L43,34 L52,34 L52,40 L43,40 L43,49 L37,49 L37,40 L28,40 L28,34 L37,34 Z\"></path> </svg> ";
// Exports
module.exports = code;